import { render } from "./Funding.vue?vue&type=template&id=5b2e9f14"
const script = {}

import exportComponent from "/Users/ra/Desktop/experiments/yasamanrafat/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__